// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-only {
    visibility: hidden;
}

@media print {
    body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    body * {
        visibility: hidden;
    }

    .print-only, .print-only * {
        visibility: visible;
    }

    .print-only {
        position: absolute;
        left: 0;
        top: 0;
        width: 210mm;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,YAAY;IAChB;AACJ","sourcesContent":[".print-only {\n    visibility: hidden;\n}\n\n@media print {\n    body {\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    body * {\n        visibility: hidden;\n    }\n\n    .print-only, .print-only * {\n        visibility: visible;\n    }\n\n    .print-only {\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 210mm;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
